import { render } from "./Maraudes.vue?vue&type=template&id=be2ba296"
import script from "./Maraudes.vue?vue&type=script&lang=js"
export * from "./Maraudes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__